import { VentilatorConstants } from './ventilator.constants'
import { IVentilatorAction, IVentilatorState } from './ventilator.types'
import { randomNumber } from '../../../../utilities'

export const initialVentilatorState: IVentilatorState = {
  ventilatorCheck: false,
  mode: null,
  breathType: null,
  settingsRespRate: '',
  tidalVolume: '',
  inspPressure: '',
  pEEP: '',
  fiO2: '',
  airTemperature: '',
  airTemperatureUnit: null,
  airTemperatureBool: true,
  humidityAir: '',
  iTime: '',
  pressureSupport: '',
  flowRate: '',
  sensitivity: '',
  meanAirwayPressure: '',
  deltaP: '',
  hertz: '',
  iNO: '',
  peakInspPressure: '',
  plateauPressure: '',
  autoPEEP: '',
  minuteVent: '',
  iERatio: '',
  measurementRespRate: '',
  exhaledTidalVolume: '',
  eTCuffPressureMeasurement: '',
  inspiratoryResistance: '',
  staticCompliance: '',
  expiratoryTimeConstant: '',
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  action: null,
  type: 'Ventilator',
  size: '',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function ventilatorReducer(
  state: IVentilatorState = initialVentilatorState,
  action: IVentilatorAction
): IVentilatorState {
  switch (action.type) {
    case VentilatorConstants.SET_VENTILATOR_CHECK:
      return { ...state, ventilatorCheck: action.ventilatorCheck }
    case VentilatorConstants.SET_MODE:
      return { ...state, mode: action.mode }
    case VentilatorConstants.SET_BREATH_TYPE:
      return { ...state, breathType: action.breathType }
    case VentilatorConstants.SET_SETTINGS_RESP_RATE:
      return { ...state, settingsRespRate: action.settingsRespRate }
    case VentilatorConstants.SET_TIDAL_VOLUME:
      return { ...state, tidalVolume: action.tidalVolume }
    case VentilatorConstants.SET_INSP_PRESSURE:
      return { ...state, inspPressure: action.inspPressure }
    case VentilatorConstants.SET_PEEP:
      return { ...state, pEEP: action.pEEP }
    case VentilatorConstants.SET_FIO2:
      return { ...state, fiO2: action.fiO2 }
    case VentilatorConstants.SET_AIR_TEMPERATURE:
      return { ...state, airTemperature: action.airTemperature }
    case VentilatorConstants.SET_AIR_TEMPERATURE_UNIT:
      return { ...state, airTemperatureBool: action.airTemperatureBool }
    case VentilatorConstants.SET_AIR_TEMPERATURE_UNIT_TEMP:
      return { ...state, airTemperatureUnit: action.airTemperatureUnit }
    case VentilatorConstants.SET_HUMIDITY_AIR:
      return { ...state, humidityAir: action.humidityAir }
    case VentilatorConstants.SET_I_TIME:
      return { ...state, iTime: action.iTime }
    case VentilatorConstants.SET_PRESSURE_SUPPORT:
      return { ...state, pressureSupport: action.pressureSupport }
    case VentilatorConstants.SET_FLOW_RATE:
      return { ...state, flowRate: action.flowRate }
    case VentilatorConstants.SET_SENSITIVITY:
      return { ...state, sensitivity: action.sensitivity }
    case VentilatorConstants.SET_MEAN_AIRWAY_PRESSURE:
      return { ...state, meanAirwayPressure: action.meanAirwayPressure }
    case VentilatorConstants.SET_DELTA_P:
      return { ...state, deltaP: action.deltaP }
    case VentilatorConstants.SET_HERTZ:
      return { ...state, hertz: action.hertz }
    case VentilatorConstants.SET_INO:
      return { ...state, iNO: action.iNO }
    case VentilatorConstants.SET_PEAK_INSP_PRESSURE:
      return { ...state, peakInspPressure: action.peakInspPressure }
    case VentilatorConstants.SET_PLATEAU_PRESSURE:
      return { ...state, plateauPressure: action.plateauPressure }
    case VentilatorConstants.SET_AUTO_PEEP:
      return { ...state, autoPEEP: action.autoPEEP }
    case VentilatorConstants.SET_MINUTE_VENT:
      return { ...state, minuteVent: action.minuteVent }
    case VentilatorConstants.SET_I_E_RATIO:
      return { ...state, iERatio: action.iERatio }
    case VentilatorConstants.SET_MEASUREMENT_RESP_RATE:
      return { ...state, measurementRespRate: action.measurementRespRate }
    case VentilatorConstants.SET_EXHALED_TIDAL_VOLUME:
      return { ...state, exhaledTidalVolume: action.exhaledTidalVolume }
    case VentilatorConstants.SET_ET_CUFF_PRESSURE_MEASUREMENT:
      return { ...state, eTCuffPressureMeasurement: action.eTCuffPressureMeasurement }
    case VentilatorConstants.SET_INSPIRATORY_RESISTANCE:
      return { ...state, inspiratoryResistance: action.inspiratoryResistance }
    case VentilatorConstants.SET_STATIC_COMPLIANCE:
      return { ...state, staticCompliance: action.staticCompliance }
    case VentilatorConstants.SET_EXPIRATORY_TIME_CONSTANT:
      return { ...state, expiratoryTimeConstant: action.expiratoryTimeConstant }
    case VentilatorConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case VentilatorConstants.SET_DATE:
      return { ...state, date: action.date }
    case VentilatorConstants.SET_TIME:
      return { ...state, time: action.time }
    case VentilatorConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case VentilatorConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case VentilatorConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case VentilatorConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case VentilatorConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case VentilatorConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case VentilatorConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case VentilatorConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case VentilatorConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case VentilatorConstants.SET_STATE:
      return { ...action.ventilatorState, updateInputRows: true }
    case VentilatorConstants.SET_ACTION:
      return { ...state, action: action.action }
    case VentilatorConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case VentilatorConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case VentilatorConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case VentilatorConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case VentilatorConstants.RESET_STATE:
      return {
        ventilatorCheck: false,
        mode: null,
        breathType: null,
        settingsRespRate: '',
        tidalVolume: '',
        inspPressure: '',
        pEEP: '',
        fiO2: '',
        airTemperature: '',
        airTemperatureUnit: null,
        airTemperatureBool: true,
        humidityAir: '',
        iTime: '',
        pressureSupport: '',
        flowRate: '',
        sensitivity: '',
        meanAirwayPressure: '',
        deltaP: '',
        hertz: '',
        iNO: '',
        peakInspPressure: '',
        plateauPressure: '',
        autoPEEP: '',
        minuteVent: '',
        iERatio: '',
        measurementRespRate: '',
        exhaledTidalVolume: '',
        eTCuffPressureMeasurement: '',
        inspiratoryResistance: '',
        staticCompliance: '',
        expiratoryTimeConstant: '',
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        action: null,
        type: 'Ventilator',
        size: '',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
